import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- NOTIFICATION ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/notifications/list',
    name: 'pages-notifications-list',
    component: () => import('@/views/pages/notification/NotificationList.vue'),
    meta: {
      resource: 'notification',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('notifications.mainVerticalMenu.notifications'),
    },
  },
  {
    path: '/notifications/add',
    name: 'pages-notifications-add',
    component: () => import('@/views/pages/notification/NotificationAdd.vue'),
    meta: {
      resource: 'notification',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('notifications.mainVerticalMenu.notifications'),
    },
  },
  {
    path: '/notifications/edit/:id',
    name: 'pages-notifications-edit',
    component: () => import('@/views/pages/notification/NotificationEdit.vue'),
    meta: {
      resource: 'notification',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('notifications.mainVerticalMenu.notifications'),
    },
  },
]
